import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as content from '../../../../content'

@ngCore.Component({
  imports: [
    ds.table.Component,
    ds.overlay.confirmation.Component,
    content.admin.modals.userAssignment.Component,
  ],
  selector: 'atn-admin-zone-page-users-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.users.Collection} */
  public readonly usersEc = ngCore.inject(state.admin.users.Collection)

  /** @see {@link state.admin.userAssignment.Feature} */
  public userAssignmentFeature = ngCore.inject(
    state.admin.userAssignment.Feature,
  )

  /** Canonical table input for users assigned to this zone. */
  public readonly usersTableConfig = {
    collection: this.usersEc,
    view: {
      creation: () => this.addClickHandlerCallback(),
      search: true,
      title: 'Users',
    },
  } satisfies ds.table.ec.Config.Input<state.admin.users.TypeParams>

  /**
   * Handles the click event on the table's add button.
   */
  public addClickHandlerCallback = () => {
    this.userAssignmentFeature.actions.setEditingMode
      .from('Admin.Zone.Users.Tab.Table.Add.Clicked')
      .dispatch({ isEditing: true })
  }

  /**
   * Discard changes for unassigning user
   */
  public cancelUnassignmentClickHandler(): void {
    this.userAssignmentFeature.actions.markUserForUnassignment
      .from('Admin.Zone.Users.Tab.Confirmation.Overlay.Cancel.Button.Clicked')
      .dispatch({ user: undefined })
  }

  /**
   * Confirm user unassignment
   */
  public confirmUnassignmentClickHandler(): void {
    const deletingAssignment =
      this.userAssignmentFeature.selectors.deletingAssignment.asSignal()
    if (deletingAssignment) {
      this.userAssignmentFeature.actions.assignAccess
        .from(
          'Admin.Zone.Users.Tab.Confirmation.Overlay.Confirm.Button.Clicked',
        )
        .dispatch({ assignments: [deletingAssignment] })
    }
  }
}
